import { ComponentProps } from 'react'

import { useResetPasscode } from '../../../hooks/useResetPasscode'
import { BlockerPasscodeEntry } from './BlockerPasscodeEntry'

export type BlockerPasscodeStepProps = ComponentProps<typeof BlockerPasscodeEntry> & {
  canResetPasscode?: boolean
}

export const BlockerPasscodeStep = ({
  name,
  mainText,
  secondaryText,
  skippable,
  onSubmit,
  form,
  canResetPasscode,
  length,
}: BlockerPasscodeStepProps) => {
  const { resetPasscodeHelpItem } = useResetPasscode()
  return (
    <BlockerPasscodeEntry
      name={name}
      mainText={mainText}
      helpModal={{ helpItems: canResetPasscode ? [resetPasscodeHelpItem] : [] }}
      skippable={skippable}
      length={length}
      onSubmit={onSubmit}
      form={form}
    />
  )
}
